import { render, staticRenderFns } from "./CreatePositions.vue?vue&type=template&id=50b186a6&"
import script from "./CreatePositions.vue?vue&type=script&lang=js&"
export * from "./CreatePositions.vue?vue&type=script&lang=js&"
import style0 from "./CreatePositions.vue?vue&type=style&index=0&id=50b186a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports